export const maskEmail = (email: string | undefined) => {
    if (!email) return '';
    const [local, domain] = email.split('@');
    if (!domain) return email;
    return `${local[0]}***@${domain}`;
};

export const maskPhone = (phone: string | undefined) => {
    if (!phone) return '';
    // Keep first 4 chars, mask the rest
    return phone.substring(0, 4) + '*'.repeat(Math.max(0, phone.length - 4));
};